export default __webpack_public_path__ + "static/char-s-sp01-ja-ebbd08a878f3dcc7bd938eb84c2ea669.png";